<section class="box-settings" *ngIf="box">
  <div *ngIf="lesson" class="prepare-lesson__header">
    <span class="prepare-lesson__header_class">{{ lesson.class_title }} класс</span>
    <div [ngStyle]="{'margin-top': '-25px'}">
      <ul class="prepare-lesson__header__list">
        <li class="prepare-lesson__header__list_subject">{{ lesson.subject }}</li>
        <li class="prepare-lesson__header__list_lesson-number">
          <a [routerLink]="['/teacher/prepare/new', lesson.id]">
            Занятие № {{ lesson.lesson_number }}
          </a>
        </li>
        <li class="prepare-lesson__header__list_date">{{ lesson.date | date: "dd.MM.yyyy г." }}</li>
      </ul>
      <p class="prepare-lesson__header__description">
        <span class="remarks"><i><b>{{ lesson.title }}</b> <small *ngIf="lesson.remarks"> ({{ lesson.remarks }}) </small></i></span>
        <span *ngIf="lesson.payment_for_task_with_cash">
          <app-svg-icon [src]="armIcon" class="svg-icon paymentForTaskWithCash">
          </app-svg-icon>
        </span>
        <span *ngIf="lesson.reward_with_cash">
          <app-svg-icon [src]="armIcon" class="svg-icon rewardWithCash">
          </app-svg-icon>
        </span>
      </p>
    </div>
  </div>
  <div class="box-settings__title">
    <h3>Бокс № {{ box?.title }}</h3>
  </div>
  <form
    *ngIf="isLoaded && box; else cardLoading"
    class="box"
    [formGroup]="boxEditForm"
    (keydown.enter)="$event.preventDefault()"
    (submit)="onBoxSave()">
    <div class="box__header">
      <span class="box-number" [class.with-risk]="withRiskBox">
        <span class="is-smart-sprint" *ngIf="activedSmartSprints.length"></span>
        <span class="box-number__title">{{ box?.title }}</span>
      </span>
      <span class="box-level">
        <label>
          Уровень
          <!-- BOX_LEVEL + -->
          <select
            formControlName="boxLevel"
            (change)="onLevelChange()">
            <option *ngFor="let level of levels" [value]="level.id">
              {{ level?.level }}
            </option>
          </select>
        </label>
      </span>
      <span class="box-description">
        <input formControlName="boxDescription" type="text" class="box-description__value">
      </span>
      <button
        *ngIf="isAccedEdit"
        class="box-generate"
        [ngClass]="{'generated': box.generated}"
        type="button"
        title="Перегенерировать вариант"
        [disabled]="!readyForGenerate()"
        (click)="generateBox()">
        <span class="fa fa-refresh box-generate__refresh-icon"></span>
      </button>
    </div>

    <div class="box__body">
      <div class="box__body__column box-tasks">
        <div class="box__body__column_title">
          <p>Задания</p>
        </div>
        <div class="box-tasks__wrapper">
          <div class="box-tasks_type">
            <span class="box__body__column__item_title">
              Тип заданий
            </span>
            <div class="box__body__column__item_content">
              <ul>
                <li *ngFor="let subtopic of initialSubtopics">
                  {{ subtopic.subtopic_title }}
                </li>
              </ul>

              <a class="edit_icon" (click)="chooseFileModal(box)">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="25" viewBox="0 0 14.3 13.1">
                  <g>
                    <path
                      d="M10.8,11.9C10.8,11.9,10.8,11.9,10.8,11.9l-9.6,0c0,0,0,0,0,0V2.3c0,0,0,0,0,0h7.2l1.2-1.2H1.2C0.5,1.1,0,1.6,0,2.3v9.6c0,0.7,0.5,1.2,1.2,1.2h9.6c0.7,0,1.2-0.5,1.2-1.2v-6l-1.2,1.2V11.9z"></path>
                    <rect x="8.5" y="0.9" transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 13.1225 14.7821)"
                          width="2.3" height="7.5"></rect>
                    <path
                      d="M14.2,0.9l-0.8-0.8C13.2,0,13,0,12.8,0.1l-0.7,0.5l1.6,1.6l0.5-0.7C14.3,1.3,14.3,1,14.2,0.9"></path>
                    <polygon points="5.5,7.2 4.2,10.1 7.1,8.8"></polygon>
                  </g>
                </svg>
              </a>
            </div>
          </div>

          <div class="box-tasks__preview_left_column">
            <div class="box-tasks_personage">
              <span class="box__body__column__item_title">
                <label class="text-normal" for="sellCharacter">Персонаж</label>
              </span>
              <span class="box__body__column__item_content">
                <!-- BOX_SELL_CHARACTER + -->
                <select
                  formControlName="boxSellCharacter"
                  (change)="getCharacter()"
                  id="sellCharacter">
                  <option value=""> ---------- </option>
                  <option *ngFor="let character of characters" [value]="character.id">
                    {{ character.title }}
                  </option>
                </select>
              </span>
            </div>
            <div class="box-tasks_count_task">
              <span class="box__body__column__item_title">
                <label class="text-normal" for="exerciseInCard">Заданий</label>
              </span>
              <span class="box__body__column__item_content">
                <!-- BOX_EXERCISES_IN_CARD + -->
                <input
                  type="number"
                  min="1"
                  max="99"
                  formControlName="boxExercisesInCard"
                  (keyup)="generatePreview()"
                  id="exerciseInCard">
              </span>
            </div>

            <div class="box-tasks_format">
              <span class="box__body__column__item_title">
                <label class="text-normal" for="cardFormat">Формат</label>
              </span>
              <span class="box__body__column__item_content">
                <!-- BOX_CARDS_FORMAT + -->
                <select
                  formControlName="boxCardsFormat"
                  (change)="generatePreview()"
                  id="cardFormat">
                  <option *ngFor="let format of paper_formats" [value]="format.value">
                    {{ format.name === 'A3' ? '1/6' : format.name }}
                  </option>
                </select>
              </span>
            </div>

            <div class="box-tasks__preview_size_format" [ngSwitch]="box.cards_format">
              <h5 *ngSwitchCase="'A6'" class="title">148 x 105 мм</h5>
              <img src="/assets/images/cards/a6.png" *ngSwitchCase="'A6'" alt="A6">

              <h5 *ngSwitchCase="'A5'" class="title">148 x 210 мм</h5>
              <img src="/assets/images/cards/a5.png" *ngSwitchCase="'A5'" alt="A5">

              <h5 *ngSwitchCase="'A3'" class="title">95 x 105 мм</h5>
              <img src="/assets/images/cards/a3.png" *ngSwitchCase="'A3'" alt="A3">

              <h5 *ngSwitchCase="'A7'" class="title">74 x 105 мм</h5>
              <img src="/assets/images/cards/a7.png" *ngSwitchCase="'A7'" alt="A7">
            </div>
          </div>

          <div class="box-tasks__preview_right_column"
               *ngIf="boxFilesIDs.length > 0 && box.exercises_in_card !== 0; else cardNotLoaded" (click)="chooseFileModal(box)">
            <div [ngSwitch]="box.cards_format" *ngIf="cardTemplate; else loading">
              <app-preview-img
                [cardsFormat]="box.cards_format"
                [box]="box"
                [boxLevels]="levels"
                [cardTemplate]="cardTemplate"
                [lessonDate]="lesson.date"
                [character]="character">
              </app-preview-img>
              <img src="/assets/images/cards/preview_A7.png" *ngSwitchCase="'A7'" alt="A7">
              <img src="/assets/images/cards/preview_A6.png" *ngSwitchCase="'A6'" alt="A6">
              <img src="/assets/images/cards/preview_A5.png" *ngSwitchCase="'A5'" alt="A5">
              <img src="/assets/images/cards/preview_A3.png" *ngSwitchCase="'A3'" alt="A3">
            </div>
            <ng-template #loading>
              <div class="box-tasks__preview__loading">
                Загрузка...
              </div>
            </ng-template>
          </div>
          <ng-template #cardNotLoaded>
            <div class="box-tasks__preview__message">
              <p *ngIf="boxFilesIDs.length === 0">Выберите файлы</p>
              <p *ngIf="box.exercises_in_card === 0">Укажите количество упражнений</p>
            </div>
          </ng-template>
        </div>
        <div class="box-tasks__count-cards">
          <label class="title" for="numberOfCards">
            Кол-во<br/>
            вариантов
          </label>
          <span class="content">
            <!-- BOX_NUMBER_OF_CARDS + -->
            <input
              type="number"
              formControlName="boxNumberOfCards"
              id="numberOfCards">
          </span>
        </div>

        <div
          *ngIf="exExercise?.id"
          class="setting"
          [class.active]="isExExerciseActive"
          (click)="isExExerciseActive = !isExExerciseActive">
          <div class="setting__box">
            <div class="setting__title exExercise_title">
              <span class="exExercise_title_message">Доп. задание</span>
              <span class="exExercise_title_reward" *ngIf="isExExerciseActive">+ {{ exExercise.reward }}</span>
            </div>
            <div class="setting__button">
              <div class="slide">
                <div class="switcher"></div>
              </div>
            </div>
          </div>
          <div
            class="setting__exExercise_title"
            [title]="exExercise.title.length > 30 ? exExercise.title : ''">
            {{ exExercise.title | shorten: 30 }}
          </div>
        </div>
      </div>

      <div class="box__body__column box-game-conditions">
        <div class="box__body__column_title">
          <select (change)="changeGameConditions($event.target.value)">
            <option value="0" [selected]="!isSmartSprintOpen">Условия игры</option>
            <option value="1" [selected]="isSmartSprintOpen">Смартспринт</option>
          </select>
        </div>
        <div *ngIf="!isSmartSprintOpen" class="game-conditions">
          <div class="box-game-conditions__settings">
            <ul>
              <li>
                <label class="box-game-conditions__settings__label" for="boxCost">Стоимость варианта</label>
                <span>
                  <input
                    type="number"
                    min="0"
                    max="99"
                    class="box-game-conditions__settings__input"
                    formControlName="boxCost"
                    #boxCost
                    [class.with-risk]="boxCost.value > 0"
                    id="boxCost">
                </span>
              </li>
              <li>
                <label class="box-game-conditions__settings__label" for="boxRewardNoRisk">Вознаграждение</label>
                <span>
                  <input
                    type="number" min="0" max="99"
                    class="box-game-conditions__settings__input"
                    formControlName="boxRewardNoRisk"
                    id="boxRewardNoRisk">
                </span>
              </li>
              <li>
                <label class="box-game-conditions__settings__label">Бонус "За всех"</label>
                <span>
                  <input
                    type="number" min="0" max="99"
                    class="box-game-conditions__settings__input"
                    formControlName="boxRewardForAll1">
                </span>
              </li>
            </ul>
            <div class="kairos-bonus" *ngIf="hasKairosBonus">
              <label
                class="kairos-bonus__label"
                for="kairosBonus"
                [class.active]="isKairosBonusActivated"
                (click)="toggleKairosBonus()">Кайрос-бонус
                <img
                  class="kairos-bonus__label__image"
                  [class.active]="isKairosBonusActivated"
                  src="/assets/images/privilege_icons/kairos_bonus_icon.png"
                  alt="Кайрос бонус">
              </label>
              <span class="kairos-bonus__input">
                <!-- KAIROS_BONUS - -->
                <input
                  type="number"
                  min="0"
                  [readOnly]="!isKairosBonusActivated"
                  class="box-game-conditions__settings__input"
                  formControlName="boxKairosBonus"
                  id="kairosBonus">
              </span>
            </div>
          </div>
          <div class="box-game-conditions__check">
            <h4 class="title">Проверка</h4>
  
            <div class="without-risk">
              <label for="checkCharacter">Проверка без риска</label>
              <!-- BOX_CHECK_CHARACTER + -->
              <select
                formControlName="boxCheckCharacter"
                id="checkCharacter">
                <option value="" selected> ----------</option>
                <option *ngFor="let character of characters" [value]="character.id">
                  {{ character.title }}
                </option>
              </select>
            </div>
  
            <div class="with-risk">
              <label for="riskCharacter">Проверка с риском</label>
              <!-- BOX_RISK_CHARACTER + -->
              <select
                formControlName="boxRiskCharacter"
                id="riskCharacter">
                <option value=""> ----------</option>
                <option *ngFor="let character of characters" [value]="character.id">
                  {{ character.title }}
                </option>
              </select>
              <span>риск</span>
              <div class="with-risk_settings">
                <ul>
                  <li>
                    <label for="rewardWithRisk">Бонус</label>
                    <!-- BOX_REWARD_WITH_RISK + -->
                    <input
                      type="number" min="0" max="99"
                      formControlName="boxRewardWithRisk"
                      id="rewardWithRisk">
                    <span>риск</span>
                  </li>
                  <li>
                    <label for="penaltyWithRisk">Штраф</label>
                    <!-- BOX_PENALTY_WITH_RISK + -->
                    <input type="number" min="0" max="99"
                           formControlName="boxPenaltyWithRisk"
                           id="penaltyWithRisk">
                    <span>риск</span>
                  </li>
                </ul>
              </div>
            </div>
  
          </div>
          <div class="box-game-conditions__additional_check">
            <h4 class="title">Дополнительная проверка</h4>
            <div class="content">
              <label for="additionalAttempts">Кол-во проверок</label>
              <!-- BOX_ADDITIONAL_ATTEMPTS -->
              <input
                type="number"
                min="0"
                max="99"
                formControlName="boxAdditionalAttempts"
                id="additionalAttempts">
            </div>
          </div>
        </div>

        <div class="smart-sprint-settings" *ngIf="isSmartSprintOpen">
          <div class="smart-sprint-settings__title">
            <span>
              Длительность <br> (секунд)
            </span>
            <span *ngIf="currentCurrency">
              Вознаграждение <br> ({{ declensionOfNumerals(5, currentCurrency) }})
            </span>
          </div>
          <div class="smart-sprint-settings__list">
            <ul>
              <li *ngFor="let item of lesson?.smart_sprints; let i = index;"
                  [class.item-active]="isActiveSmartSprint(item)">
                <div class="item-number">{{ i + 1 }}.</div>
                <div class="smart-sprint-settings__list_item">
                  <span class="smart-sprint-settings__list_item__successed" (click)="toggleTimeSuccessedSprint(item)">
                    {{ getTimeSuccess(item) }}
                  </span>
                  <span><b>{{ item.duration }}</b></span>
                  <span><small><font color="#9abae6">---></font></small></span>
                  <span *ngIf="boxLevel"><b>{{ [0, 9].includes(boxLevel) ? item.reward : item.reward * boxLevel }}</b></span>
                  <span *ngIf="!boxLevel"><b>{{ item.reward }}</b></span>
                  <span (click)="toggleSmartSprintItem(item)">
                    <div class="setting__button">
                      <div class="slide">
                        <div class="switcher"></div>
                      </div>
                    </div>
                  </span>
                </div>
              </li>
            </ul>
          </div>
          <span>
            <label>Бонус "За всех"</label>
            <span>
              <input formControlName="boxRewardForAll2" type="number" min="0" max="99">
            </span>
          </span>
        </div>
      </div>

      <div class="box__body__column">
        <div *ngIf="lesson?.is_habirint" class="box-habirint">
          <span class="box__body__column_title">
            <p>Хабиринт</p>
          </span>
          <span (click)="isHabirintBox = !isHabirintBox"
            class="box-habirint__body" [class.box-habirint__active]="isHabirintBox">
            <div class="box-habirint__body__toggle__title">
              {{ isHabirintBox ? 'Включен' : 'Выключен' }}
            </div>
            <div class="box-habirint__body__toggle__slide">
              <div class="box-habirint__body__toggle__slide__switcher"></div>
            </div>
          </span>
        </div>
        <div *ngIf="privilegeSettings.length > 0" class="box-privileges">
          <div class="box__body__column_title">
            <p>Привилегии</p>
          </div>
          <div>
            <ul class="box-privileges__list">
              <li
                class="setting"
                [class.active]="isActivePrivilege(setting)"
                *ngFor="let setting of privilegeSettings; let i = index;"
                (click)="togglePrivilegeSetting(setting)">
                <div class="setting__box">
                  <div class="setting__placeholder">
                    {{i + 1}}
                  </div>
                  <img
                    class="setting__image"
                    [src]="mainDomain + setting.character.icon_url"
                    [alt]="setting.character.title">
                  <div class="setting__title">
                    {{ setting.character.title }}
                  </div>
                  <div class="setting__button">
                    <div class="slide">
                      <div class="switcher"></div>
                    </div>
                  </div>
                </div>
                <div
                  class="setting__privilege"
                  [title]="setting.privilege.title.length > 30 ? setting.privilege.title : ''">
                  {{setting.privilege.title | shorten: 30}}
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="box-comments">
          <div class="box__body__column_title">
            <p>Комментарий</p>
          </div>
          <div class="box-comments__form">
            <textarea formControlName="boxComment" cols="30" rows="10">
              {{ box?.comment }}
            </textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="box__footer">
      <div class="row">
        <div class="top col text-center">
          <button class="btn-cancell" type="button" (click)="onCancel()">ОТМЕНА</button>
          <button class="btn-confirm" type="submit" [disabled]="boxEditForm.invalid || !isAccedEdit">ОК</button>
        </div>
      </div>
    </div>
  </form>
  <ng-template #cardLoading>
    <div class="preloader-wrapper">
      <mat-progress-spinner
          class="spinner"
          mode="indeterminate">
      </mat-progress-spinner>
    </div>
  </ng-template>
</section>
